import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

enum CacheKey {
  OrganizationUsers = 'OrganizationUsers',
}

export const useRemoveUserFromOrganizationMutation = () => {
  const { removeUserFromOrganization } = useServicesContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId: number) => removeUserFromOrganization(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CacheKey.OrganizationUsers],
      });
    },
  });
};